/**
 * Champ d'un montant saisi au clavier ou au pave : affiche le montant
 * formate (formatMontant du contrat), recoit les chiffres, ⌫ et Entree.
 * Pas de clavier virtuel (inputMode none) : le pave est a l'ecran.
 */
import { forwardRef } from 'react';
import Box from '@mui/material/Box';
import { formatMontant } from '../vente/contrat';
import { palette } from '../app/theme';

const ChampMontant = forwardRef(function ChampMontant({
    id, label, cents, disabled = false, onChiffres, onEffacer, onValider, testId,
}, ref) {
    const onKeyDown = (event) => {
        if (/^\d$/.test(event.key)) {
            event.preventDefault();
            onChiffres(event.key);
        } else if (event.key === 'Backspace') {
            event.preventDefault();
            onEffacer();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (onValider) onValider();
        }
    };
    return (
        <Box>
            <Box component="label" htmlFor={id} sx={{ display: 'block', fontSize: 18, fontWeight: 600, color: palette.textSecondary, mb: 1 }}>
                {label}
            </Box>
            <Box
                component="input"
                ref={ref}
                id={id}
                data-testid={testId}
                data-cents={cents}
                type="text"
                inputMode="none"
                autoComplete="off"
                readOnly
                disabled={disabled}
                value={formatMontant(cents)}
                onKeyDown={onKeyDown}
                sx={{
                    width: '100%', height: 72, border: `3px solid ${palette.primary}`, borderRadius: '12px', px: 2.5,
                    textAlign: 'right', fontSize: 40, fontWeight: 800, color: palette.text, bgcolor: palette.surface,
                    fontFamily: 'inherit', fontVariantNumeric: 'tabular-nums', caretColor: 'transparent',
                    '&:focus-visible': { outline: `3px solid ${palette.primary}`, outlineOffset: 2 },
                }}
            />
        </Box>
    );
});

export default ChampMontant;
